/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {

                getLibObject("helper").checkMobile();

                $(".preistraeger .owl-carousel").owlCarousel({
                    items: 5,
                    margin: 30,
                    loop: true,
                    nav: true,
                    dots: false,
                    responsive: {
                        0: {
                            items: 1
                        },
                        576: {
                            items: 2
                        },
                        768: {
                            items: 3
                        },
                        992: {
                            items: 4
                        },
                        1200: {
                            items: 5
                        }
                    },
                    onInitialized: function(event){
                        /*$(".preistraeger .owl-carousel").each(function(){
                            $(this).find(".preistraeger__name").matchHeight();
                        });*/
                        // $(".preistraeger .preistraeger__sum").matchHeight();
                    },
                    onRefreshed: function(event){
                        // prevent flash of unstyled boxes on tab change
                        var target = $(event.target);
                        if(target.hasClass("waiting-for-initial-refresh")) {
                            target
                                .removeClass("waiting-for-initial-refresh")
                                .find(".preistraeger__single--hidden")
                                .removeClass("preistraeger__single--hidden")
                                .find(".preistraeger__name")
                                .matchHeight();
                        }
                        $.fn.matchHeight._update();
                    }
                });


                // smooth scrolling for all internal links
                //$('a').smoothScroll();
                $('body').scrollspy({target: '#scrollspy-menu'});
                getLibObject("helper").fixScrolldownLinks();
                $(".socialsharing-button .icon-share").click(function (e) {
                    $(this).closest(".socialsharing-button").toggleClass("open");
                    e.preventDefault();
                });

                //news h4 same height
                jQuery("#news").find(".row > li > h4").matchHeight();

                // session h4 same height
                jQuery("#topics").find(".session article h4").matchHeight();

                // info block h4 same height
                jQuery("#infos").find(".row > li > h4").matchHeight();

                jQuery("#experts").find(".row > li > .wp-image").matchHeight(); // only for smaller images relevant
                jQuery("#experts").find(".row > li > h4").matchHeight();
                getLibObject("helper").setVimeoThumbnails();

                if ($("body").hasClass("logged-in")) {
                    if(ajax_variables.hasOwnProperty('thementag_id')) {
                        jQuery.ajax({
                            type : "post",
                            dataType : "json",
                            url : ajax_variables.ajax_url,
                            data : {action: 'vr_log_pageview', post_id: ajax_variables.thementag_id}
                        });
                    } else {
                        jQuery.ajax({
                            type : "post",
                            dataType : "json",
                            url : ajax_variables.ajax_url,
                            data : {action: 'vr_log_pageview', post_id: ajax_variables.post_id}
                        });
                    }
                }

                var mouseX;
                var mouseY;
                $(document).mousemove( function(e) {
                    mouseX = e.clientX;
                    mouseY = window.innerHeight - e.clientY;
                });
                if($(window).width() > 991) {
                    $("#experts ul li").mousemove(function(){
                        $(this).find('.popup-content').css({'bottom':mouseY,'left':mouseX});
                    });
                } else {
                    $("#experts ul li").on('touchstart', function(){
                        $(this).find('.popup-content').css({'bottom':0,'left':0,'width':'100%'});
                    });
                }

                // bvr changes
                wp.hooks.doAction( 'commonInit' );
                getLibObject("helper").log("triggered commonInit");
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                /*if(getLibObject("config").websocketEnabled && getLibObject("config").websocketEnabledFor.frontpage && $("body").hasClass("logged-in")) {
                    var success = getLibObject("websocket").initFrontpage();
                    getLibObject("config").websocketSuccess = success;
                }*/

                if ($("body").hasClass("logged-in")) {
                    getLibObject("savethedate").saveTheDateFormHandler();
                    getLibObject("savethedate").saveASessionFormHandler();
                }

                jQuery("#topics").find(".session article .excerpt").dotdotdot({
                    watch: true
                });
                jQuery("#topics").find(".session article .intro-excerpt").dotdotdot({
                    watch: true
                });

                $("#scrollspy-menu").find(".nav a").on("click", function () {
                    $(this).parent().parent().find(".active").removeClass("active");
                    $(this).parent().addClass("active");
                });

                //$(".fancybox-inline").fancybox();

                getLibObject("dots").ExpertDots.init('#expert-dots > div', '.expert');

                //slider match height

                $("#quote-list.carousel").matchHeight();
                $("#news-list.carousel").matchHeight();
                $("#magazine-list.carousel").matchHeight();

                //countdown
                if($('#countdown-timer-front').length > 0) {
                    var dateFront = new Date($('#countdown-timer-front').attr("datetime"));
                    getLibObject("countdown").startCountdown(dateFront, "#countdown-timer-front");
                } else {
                    var date = new Date($('#countdown-timer').attr("datetime"));
                    getLibObject("countdown").startCountdown(date);
                }

                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                //vimeo header background player
                var id = $("#playerHeader").attr("data-ytid");
                var type = $("#playerHeader").attr("data-player");

                if (type === "vimeo") {
                    getLibObject("player").createVimeoPlayer(id, 'vimeo_player', 1, true);
                }

                $("#topics .video-content [data-player=vimeo]").each(function () {

                    if ($(this).length > 0) {
                        var elementid = $(this).attr("data-iframeid");
                        getLibObject("player").createVimeoPlayer(null, elementid, 0, false);

                        var iframe = $('#'+$(this).attr("data-iframeid"))[0];
                        var player = new Vimeo.Player(iframe);
                        $(this).find('.overlay-thumbnail').on('click',function(){
                            $(this).remove();
                            player.play();
                        });
                    }
                });

                // gallery
                var gallery = $("#gallery");
                if (gallery.length) {
                    gallery.find(".fancybox-image").fancybox({
                        helpers: {
                            title: {type: 'inside'}
                        }, // helpers
                        beforeLoad: function () {
                            this.title = $(this.element).attr('caption');
                        }
                    });
                }

                onYouTubeIframeAPIReady = function () {
                    if (type === "youtube") {
                        getLibObject("player").createBackgroundPlayer(id, 'playerHeader');
                    }

                    $("#topics .video-content [data-player=youtube]").each(function () {

                        if ($(this).length > 0) {
                            var youtubeid = $(this).attr("data-ytid");
                            var elementid = $(this).attr("data-elid");
                            // $(this).find(".icon-play").css("display", "none");
                            getLibObject("player").createPlayer(youtubeid, elementid, false);
                        }

                    });
                };

                $(window).scroll(function(){
                    var sticky = $('#head'),
                        scroll = $(window).scrollTop(),
                        stickyHeight = sticky.outerHeight();

                    if (scroll >= stickyHeight) {
                        $('#head-fixed').show();
                    } else {
                        $('#head-fixed').hide();
                    }
                });
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        'single_thementag': {
            init: function () {
                getLibObject("player").disableWebsocketIfAfterEventDay();
                getLibObject("player").disableWebsocketIfBeforeEventDay();
                if(getLibObject("config").websocketEnabled && getLibObject("config").websocketEnabledFor.single_thementag ) {
                    var success = getLibObject("websocket").initSession();
                    getLibObject("config").websocketSuccess = success;
                }

                // replace :grinning etc. after load
                // Todo: move to php
                $('#ticker,#top5').find('.comment-list .comment-content').each(function(index){
                    var el = $(this);
                    var html = el.html();
                    el.html(getLibObject('comments').replaceSmileys(html));
                });

                if ($("body").hasClass("logged-in")) {
                    getLibObject("savethedate").saveTheDateFormHandler();
                    getLibObject("savethedate").saveASessionFormHandler();
                }

                // general stuff
                $("#quote-list.carousel").matchHeight();

                $(".emoji-popover").popover({
                    container: $(".comment-form-comment"),
                    content: '<div class="emoji-links">' +
                        '<a href="#" aria-label=":grinning:" data-emoji="😀">😀</a>' +
                        '<a href="#" aria-label=":thumbsup:" data-emoji="👍">👍</a>' +
                        '<a href="#" aria-label=":thumbsdown:" data-emoji="👎">👎</a>' +
                        '<a href="#" aria-label=":clap:" data-emoji="👏">👏</a>' +
                        //'<a href="#" aria-label=":partying_face:" data-emoji="🥳">🥳</a>' +
                        //'<a href="#" aria-label=":champagne_glass:" data-emoji="🥂">🥂</a>' +
                        '</div>',
                    html: true,
                    placement: "left",
                    trigger: "click focus"
                });

                $("body").on("click",".emoji-links a",function(e){
                    e.preventDefault();
                    var commentInput = $('#comment');
                    var val = commentInput.val();
                    var elA;
                    if(e.target.nodeName === "IMG") {
                        elA = $(e.target).parents("a");
                    } else {
                        elA = $(e.target);
                    }
                    commentInput.val(val + elA.attr("data-emoji"));
                    commentInput.focus();
                    // fix strange behavior where first click after hide did nothing ...
                    $('.emoji-popover').trigger("click");
                    //$('.emoji-popover').popover('hide');
                });

                var counter = $('.char-counter');

                $('#comment').on('keyup change', function(){
                    var count = $(this).val().length;

                    counter.text(count+'/250');
                });

                // comment-form-comment

                // gallery
                var gallery = $("#gallery");
                if (gallery.length) {
                    gallery.find(".fancybox-image").fancybox({
                        helpers: {
                            title: {type: 'inside'}
                        }, // helpers
                        beforeLoad: function () {
                            this.title = $(this.element).attr('caption');
                        }
                    });
                }

                if ($("body").hasClass("logged-in")) {
                    // init ajax call
                    // also handles websocket comments
                    getLibObject("comments").initComment();
                }

                getLibObject("player").initVars();
                getLibObject("player").determineMode();

                getLibObject("dots").DotsReplacementEliptic.init('.bubble-container', '.bubble', {});
                getLibObject("dots").DotsReplacementEliptic.start();
                getLibObject("comments").loadPopupsFromComments();

                getLibObject("savethedate").saveTheDateFormHandler();
                getLibObject("poll").pollVotingHander();
                getLibObject("comments").votingTop5ClickHandler();
                getLibObject("comments").votingClickHandler();
                getLibObject("comments").initVimeoChapterLinks();

                getLibObject("comments").commentScroller('#ticker .scroller');
                getLibObject("comments").commentScroller('#top5 .scroller');

                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                var id = $("#playerHeader").attr("data-ytid");
                var type = $("#playerHeader").attr("data-player");

                if (type === "vimeo") {
                    getLibObject("player").createVimeoPlayer(id, 'vimeo_player', 1, true);
                }

                $("#magazine-list .wp-video [data-player=vimeo], " +
                    "#experts .wp-video [data-player=vimeo]").each(function () {

                    //var teaservideo = $(this).find(".teaservideo");
                    if ($(this).length > 0) {
                        var elementid = $(this).attr("data-iframeid");
                        getLibObject("player").createVimeoPlayer(null, elementid, 0, false);
                    }
                });

                onYouTubeIframeAPIReady = function () {
                    if (type === "youtube") {
                        getLibObject("player").createBackgroundPlayer(id, 'playerHeader');
                    }

                    $("#magazine-list .wp-video [data-player=youtube], " +
                        "#experts .wp-video [data-player=youtube]").each(function () {
                        //var teaservideo = $(this).find(".teaservideo");
                        if ($(this).length > 0) {
                            var youtubeid = $(this).attr("data-ytid");
                            var elementid = $(this).attr("data-elid");
                            // $(this).find(".icon-play").css("display", "none");
                            getLibObject("player").createPlayer(youtubeid, elementid, false);
                        }
                    });
                };

                var currentTimeTimestamp = parseInt($("#player").attr("data-currentTime"));
                var startTimeTimestamp = parseInt($("#player").attr("data-startTime"));
                var startFrontTimeTimestamp = parseInt($("#countdown-timer-front").attr("timestamp"));

                var timeDifference = startTimeTimestamp - currentTimeTimestamp;
                var timeDifferenceFront = startFrontTimeTimestamp - currentTimeTimestamp;
                var calculatedStartDate = 0;
                var now = new Date();

                // calculate differen betweeen date from html and startdate from html
                // add difference to current local time

                if(timeDifference > 0) {
                    calculatedStartDate = new Date( now.getTime() + (timeDifference * 1000) );
                    getLibObject("countdown").startCountdown(calculatedStartDate);
                } else {
                //exchange countdown with info text during and after the event
                    getLibObject("countdown").showCountdownInfo();
                }

                if(timeDifferenceFront > 0) {
                    calculatedStartDate = new Date( now.getTime() + (timeDifferenceFront * 1000) );
                    getLibObject("countdown").startCountdown(calculatedStartDate, '#countdown-timer-front');
                } else {
                    //exchange countdown with info text during and after the event
                    getLibObject("countdown").showCountdownInfo();
                }

                getLibObject("countdown").setPlaceHolder("#comment");
            },
            finalize: function () {

            }
        },
        // About us page, note the change from about-us to about_us.
        'single_person': {
            init: function () {
                /*dots.Dots.init('#expert-dots', '.expert', {
                 limit: 50, // distance randomised elements will stay away from parent's edge
                 mount: 20, // extra space (similar to margin) added around each random element
                 initial: 1 // number of elements to initially place inside quadrants
                 });
                 dots.Dots.start();*/
                getLibObject("dots").ExpertDots.init('#expert-dots > div', '.expert');

                $("#quote-list.carousel").matchHeight();

                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                $("#experts-detail .wp-video [data-player=vimeo]").each(function () {
                    if ($(this).length > 0) {
                        var elementid = $(this).attr("data-iframeid");
                        getLibObject("player").createVimeoPlayer(null, elementid, 0, false);
                    }
                });

                onYouTubeIframeAPIReady = function () {
                    $("#experts-detail .wp-video [data-player=youtube]").each(function () {
                        if ($(this).length > 0) {
                            var youtubeid = $(this).attr("data-ytid");
                            var elementid = $(this).attr("data-elid");
                            getLibObject("player").createPlayer(youtubeid, elementid, false);
                        }
                    });
                };
            },
            finalize: function () {

            }
        },
        'page_template_page_magazin_trailer': {
            init: function () {

                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                $(".page-template-page_magazin-trailer .wp-video [data-player=vimeo]").each(function () {
                    if ($(this).length > 0) {
                        var elementid = $(this).attr("data-iframeid");
                        getLibObject("player").createVimeoPlayer(null, elementid, 0, false);
                    }
                });

                onYouTubeIframeAPIReady = function () {
                    $(".page-template-page_magazin-trailer .wp-video [data-player=youtube]").each(function () {
                        if ($(this).length > 0) {
                            var youtubeid = $(this).attr("data-ytid");
                            var elementid = $(this).attr("data-elid");
                            getLibObject("player").createPlayer(youtubeid, elementid, false);
                        }
                    });
                };
            },
            finalize: function () {

            }
        }, // bvr changes
        'page_template_page_mod_comments': {
            init: function () {
                var counter = 15,
                    element = $('#counter'),
                    second = 1000;

                setInterval(function () {
                    window.location.reload();
                    $.ajax({
                        url: window.location.href,
                        success: function (data, response, xhr) {
                            if (xhr.status === 200) {
                                var html = $(data);
                                var content = $('#mod-comments', html);
                                if (content.length) {
                                    var element = $('#mod-comments'),
                                        parent = element.parent();
                                    element.remove();
                                    parent.append(content);
                                }

                            }
                        },
                        type: "GET",
                        dataType: "text"
                    });
                }, counter * second);

                if (element.length) {
                    var id = setInterval(function () {
                        counter--;
                        if (counter < 1) {
                            clearInterval(id);
                        } else {
                            element.text(counter);
                        }
                    }, second);
                }
            },
            finalize: function () {

            }
        },
        'page_template_page_mod_comments_dynamic': {
            init: function () {

                getLibObject("helper").log("triggered page_template_page_mod_comments_dynamic");

                // init websocket
                if(getLibObject("config").websocketEnabled && getLibObject("config").websocketEnabledFor.mod_comments) {
                    var success2 = getLibObject("websocket").initModComments();
                    getLibObject("config").websocketSuccess = success2;
                }
            },
            finalize: function () {

            }
        },
        'page_template_page_poll_answers': {
            init: function () {

                getLibObject("poll").addPollResultClick();

                setInterval(function () {
                    // window.location.reload();

                    $.ajax({
                        url: window.location.href,
                        success: function (data, response, xhr) {
                            if (xhr.status === 200) {
                                var html = $(data);
                                window.html_data = html;
                                var content = $(data).find('#poll-results > .row');

                                if (content.length) {
                                    var element = $('#poll-results > .row'),
                                        parent = element.parent();
                                    element.remove();
                                    parent.append(content);

                                    if(getLibObject("config").umfrage_bars_visible) {
                                      $("#poll-results").find(".pollbar").each(function () {
                                        var percent = $(this).attr("data-pollbarwidth");
                                        $(this).find(".percentage").text(percent + "%");
                                        $(this).css({'width': percent + "%"});
                                      });
                                    } else {
                                      $("#poll-results").click(function (e) {
                                        e.preventDefault();
                                        var that = $(this);
                                        that.find(".pollbar").each(function () {
                                          var percent = $(this).attr("data-pollbarwidth");
                                          $(this).animate({'width': percent + "%"});
                                          $(this).find(".percentage").text(percent + "%");
                                        });
                                        getLibObject("config").umfrage_bars_visible = true;
                                        $("#poll-results").off("click");
                                      });
                                    }
                                }

                            }
                        },
                        type: "GET",
                        dataType: "text"
                    });

                }, 30000);
            },
            finalize: function () {

            }
        },
        'page_template_page_poll_answers_dynamic': {
            init: function () {
                if(getLibObject("config").websocketEnabled && getLibObject("config").websocketEnabledFor.umfrage) {
                    var success3 = getLibObject("websocket").initPoll();
                    getLibObject("config").websocketSuccess = success3;
                }

                getLibObject("poll").addPollResultClick();
            },
            finalize: function () {

            }
        },
        'page_template_page_user_fragen': {
            init: function () {
                // reload ajax call

                setTimeout(function () {
                    var session = $('#zuschauer-bubbles').attr('data-session'); // only active on thementag (and after?)
                    if (session) {
                        getLibObject("ajax").ajax_general("user_questions", "reload", getLibObject("ajax").user_fragen_reload, {session: session});
                    }
                    window.reloadAjaxInterval = setInterval(function () {
                        if (session) {
                            getLibObject("ajax").ajax_general("user_questions", "reload", getLibObject("ajax").user_fragen_reload, {session: session});
                        }
                    }, 3000);
                }, 1000);
            },
            finalize: function () {
            }
        },
        'page_template_page_user_fragen_dynamic': {
            init: function () {
              // reload ajax call

                getLibObject("helper").log("triggered page_template_page_mod_comments_dynamic");

                // init websocket
                if(getLibObject("config").websocketEnabled && getLibObject("config").websocketEnabledFor.user_fragen) {
                    getLibObject("config").websocketSuccess = getLibObject("websocket").initUserBubbleScreen();
                }
            },
            finalize: function () {
            }
        },
        'feedback': {
            init: function () {
                jQuery(".radio-rating").append("<div class='clear'></div>").find(">label, >div>ul>li").matchHeight(); // match form radio heights
                jQuery(".radio-yesno").append("<div class='clear'></div>").find(">label, >div>ul>li").matchHeight(); // match form radio heights
            },
            finalize: function () {

            }
        },
        'page_template_page_kontakt': {
            init: function () {
                // getLibObject("ajax").ajax_general("template_kontakt", "init", getLibObject("ajax").kontakt_init, {});
            },
            finalize: function () {

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


